export const NonZeroToDisplayString = (value?: number | null, decimals?: number, postfix?: string): string => {
    postfix ??= '';
    decimals ??= 2;
    return value && Math.abs(value) > 0.001 ? `${value.toFixed(decimals)}${postfix}` : '';
}
export const NonZeroToPercentString = (value?: number | null, decimals?: number): string => {
    return NonZeroToDisplayString(value, decimals, '%');
}
